import React, { useState } from 'react'

export default function TodoItem(props) {

    const [isEditing, setIsEditing] = useState(false);
    const [inputValue, setInputValue] = useState(props.title);
    const [tempValue, setTempValue] = useState(props.title);
    const [isDone, setIsDone] = useState(props.isDone); 

    const handleDivDoubleClick = () => {
        isEditing ? setIsEditing(false) : setIsEditing(true);
    };

    const handleInputKeyDown = (e) => {
        const key = e.keyCode;
        if (key === 13) {       // Go back to text after exit key or enter key is pressed 
            props.editTodo({ title : tempValue });
            setInputValue(tempValue);
            setIsEditing(false);
        }
        else if (key === 27) {
            setTempValue(inputValue);
            setIsEditing(false);
        }
    };

    const handleInputChange = (e) => {
        setTempValue(e.target.value);
    };

    const handleCheckClick = () => {
        setIsDone((oldIsDone) => {
            const newState = !oldIsDone;
            props.editTodo({ isDone : newState });
            return newState;
            }
            );
    };

    return (
            isEditing ?
                <div className="row" onDoubleClick={handleDivDoubleClick}>
                <div className="column seven wide">
                    <div className="ui input fluid">
                        <input
                            value={tempValue}
                            autoFocus={true}
                            type="text" onKeyDown={handleInputKeyDown}
                            onChange={handleInputChange}
                        />
                    </div>
                    </div>
                </div> :
                <>  
                <div className="row">
                    <div className="column five wide" onDoubleClick={handleDivDoubleClick}>
                        {isDone?<s><h3 className="ui header">{inputValue}</h3></s>:<h3 className="ui header">{inputValue}</h3>}
                    </div>
                    <div className="column one wide">
                        <button className={"ui button circular icon" + (isDone? " blue":" green")} onClick={handleCheckClick}  >
                            <i className="white check icon"></i>
                            </button>
                    </div>
                    <div className="column one wide">
                        <button className="ui button circular icon red" onClick={props.deleteTodo} ><i className="white remove icon"></i></button>
                    </div>
                    </div>
            </>    
    );
};
